// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"454":"20e8798e","630":"f3b4057d"}[chunkId] + ".chunk.css";
};